import styled from "styled-components";

const DESKTOP = "@media (min-width: 768px)";

export const SectionTitle = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	color: #e5f0fe;
	font-size: 16px;
	font-weight: 400;
	line-height: 1.1;

	svg,
	img {
		flex-shrink: 0;
		width: 16px;
		height: 16px;
		display: block;
		object-fit: contain;
	}

	${DESKTOP} {
		font-size: 16px;
		line-height: normal;

		svg,
		img {
			width: 24px;
			height: 24px;
		}
	}
`;

export const SliderControls = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	flex-shrink: 0;
`;

export const SliderArrowIcon = styled.img`
	width: 30px;
	height: 30px;
	display: block;
	transition: filter 0.2s ease;
	transform: ${({ $mirrored }) => ($mirrored ? "rotate(180deg)" : "none")};
`;

export const SliderArrowButton = styled.button`
	display: none;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	padding: 0;
	cursor: pointer;
	border: none;
	flex-shrink: 0;
	background: transparent;
	transition: opacity 0.2s ease;

	${DESKTOP} {
		display: flex;
	}

	&:hover:not(:disabled) ${SliderArrowIcon} {
		filter: brightness(1.25) drop-shadow(0 0 3px rgba(229, 240, 254, 0.65));
	}

	&:disabled {
		opacity: 0.4;
		cursor: default;
	}
`;

export const SectionAllButton = styled.button`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	flex-shrink: 0;
	height: auto;
	padding: 6px 12px 4px;
	border-radius: 8px;
	border: none;
	background: #0362d4;
	color: #ffffff;
	font-family: var(--bt-font-family);
	font-size: 14px;
	font-weight: 600;
	line-height: 1.4;
	text-transform: capitalize;
	white-space: nowrap;
	cursor: pointer;
	-webkit-font-smoothing: antialiased;
	transition:
		background 0.2s,
		filter 0.2s;

	&:hover {
		background: #0456bd;
		filter: none;
	}

	${DESKTOP} {
		height: 30px;
		padding: 0 12px;
		background: #202534;
		color: #e5f0fe;
		font-weight: 400;
		line-height: normal;
		letter-spacing: normal;
		text-transform: none;

		&:hover {
			background: #2a3142;
			filter: brightness(1.08);
		}
	}
`;
